import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from '../../environments/environment';

import 'rxjs/add/operator/toPromise';

import { TaxGroup } from '../models/tax-group';

@Injectable()
export class TaxGroupService {

  constructor(private http: HttpClient) { }

  getTaxGroup(invoiceId: string, ChamberID: string): Promise<any> {
    return this.http.get<TaxGroup>(environment.apiURL + 'taxgroup' + '?chamberid=' + ChamberID + '&invoiceid=' + invoiceId)
    .toPromise()
    .then(response => response)
    .catch(error => Promise.reject('Désolé! Les taxes sont introuvable...'));
  }
}



// WEBPACK FOOTER //
// /home/ubuntu/MembriPay/src/app/services/tax-group.service.ts